module.exports = __webpack_public_path__ + "4304c9718481b8ab53c533b50394d169.png";